import { getEnv } from "@istari-frontend/shared";

const isNewSystemsEnvEnabled = getEnv("VITE_NEW_SYSTEMS_ENABLED") === "true";

export function useIsNewSystemsEnabled(): boolean {
  return isNewSystemsEnvEnabled;
}
